import { useDispatch } from 'react-redux';

const useNotification = () => {
  const dispatch = useDispatch();

  const showNotification = ({
    message,
    type,
    status = true,
    link = null,
    description,
    position = null,
    duration = null,
    onClose = null,
    pauseOnHover = true,
  }) => {
    dispatch({
      type: 'NOTIFICATION',
      payload: {
        message,
        type,
        status,
        link,
        description,
        position,
        duration,
        onClose,
        pauseOnHover,
      },
    });
  };

  return showNotification;
};

export default useNotification;
